import { render, staticRenderFns } from "./agentMeal.vue?vue&type=template&id=3c11fb20&"
import script from "./agentMeal.vue?vue&type=script&lang=js&"
export * from "./agentMeal.vue?vue&type=script&lang=js&"
import style0 from "./agentMeal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports